import validate, { ValidateRuleI } from '@/lib/validate';
import { message } from 'ant-design-vue';
// import MockPath from '@/mock/mock_api';
// import axios from 'axios';
import api from '@/axios/api';
import { reactive, ref, toRaw } from 'vue';
import {
  RouteLocationNormalizedLoaded, Router, useRoute, useRouter,
} from 'vue-router';
import Editor from 'wangeditor';
import { definitions } from '@/types/api';
import { JobBasicInfoI } from './interface';

// const mockPath = new MockPath();

/** save接口数据转换 */
const apiSaveData = (data: JobBasicInfoI): definitions['CustomCaseAssignment'] => ({
  id: data.id || undefined,
  assignmentName: data.jobName,
  caseDetails: data.jobInfomation,
  knowledgeSystem: data.jobKnowledge,
});
/** query转换 */
export const apiQueryData = (data: definitions['CustomCaseAssignment']): JobBasicInfoI => ({
  id: data.id || '',
  jobName: data.assignmentName || '',
  jobInfomation: data.caseDetails || '',
  jobKnowledge: data.knowledgeSystem || '',
});

export class JobBasicInfo {
  saving = ref(false);

  quering = ref(false);

  formState: JobBasicInfoI = reactive({
    jobName: '',
    jobKnowledge: '',
    jobInfomation: '',
    id: '',
  })

  rules: ValidateRuleI = reactive({
    jobName: [{ required: true, message: '请输入作业名称' }],
    jobKnowledge: [{ required: true, message: '请输入知识体系' }],
    jobInfomation: [{ required: true, message: '请输入案例详情' }, { max: 10000, message: '最多输入10000个字符' }],
  })

  editor!: Editor;

  router: Router;

  route!: RouteLocationNormalizedLoaded;

  constructor() {
    this.route = useRoute();
    this.router = useRouter();
    console.log(toRaw(this.formState), 'this.formState');
    console.log(this.route.params, 'parms');
    if (this.route.params.jobId) {
      this.formState.id = this.route.params.jobId as string;
      console.log(this.route.params, 'parms');
    }
    this.queryJobBasicInfo();
  }

  async queryJobBasicInfo() {
    if (!this.formState.id) return;
    this.quering.value = true;
    // const { data } = await axios.post(mockPath.getJobBasicInfo, this.formState.id);
    const { data } = await api.queryCustomCaseAssignmentById(this.formState.id);
    console.log(data, 'data');
    Object.assign(this.formState, apiQueryData(data.data));
    this.quering.value = false;
  }

  async saveJobBasicInfo() {
    validate(this.formState, this.rules);
    this.saving.value = true;
    // const { data } = await axios.post(mockPath.saveJobBasicInfo, this.formState);
    const { data } = await api.editCustomCaseAssignment(apiSaveData(this.formState));
    console.log(data, 'data');
    if (data.success) {
      message.success('保存成功');
      this.formState.id = data.data.id;
      this.saving.value = false;
      this.router.push({
        path: `/Teacher/addJob/${data.data.id}`,
        query: {
          ...this.route.query,
        },
      });
    }
    return data;
  }
}

export class JobBasicInfoController {
  jobBasicInfo!: JobBasicInfo;

  constructor(jobBasicInfo: JobBasicInfo) {
    this.jobBasicInfo = jobBasicInfo;
  }

  handleMounted(editor: Editor) {
    this.jobBasicInfo.editor = editor;
  }
}
